export default {
  "content": "<title>Transgender</title><circle cx=\"256\" cy=\"256\" r=\"128\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M448 352l-96 96M176 80l-95.98 95.98M464 128V48h-80M48 128V48h80m336 0L346.5 165.5M48 48l117.49 117.49M464 464L346.65 346.37\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};